import { createContext, useContext, useEffect, useState } from "react"
import vconst from "utils/helpers/structs/vconst";
import { useAuth } from "context/AuthContext";
import useSettingsParams from "hooks/useSettingsParams";
import { safeJSONParse } from "utils/helpers/safeParsing";
import { _localGet, _localSet } from "utils/helpers/gimHelper";

const ObjectContext = createContext();
export const useObject = () => useContext(ObjectContext); 

const deObjecttatus = [
    vconst.objectInWork,
    vconst.objectPanding,
    vconst.objectFinishedTeam];

export { deObjecttatus as defaultObjectStatuses };

const SHOW_DEBTOR_STORAGE_KEY = 'objectListShowDebtor';

const readShowDebtor = () => {
    try {
        return _localGet(SHOW_DEBTOR_STORAGE_KEY) === '1';
    } catch {
        return false;
    }
};
 
export const ObjectProvider = ({children}) => {
   
    const { auth } = useAuth();
    const params = useSettingsParams();
    const filterName  = `voltox-${auth.user.ID}-object-filter`;
    const orderName  = `voltox-${auth.user.ID}-object-order`;
    const descName  = `voltox-${auth.user.ID}-object-desc`;    

    const [ showSpinner, setShowSpinner ] = useState(false);
    const [ listResetNonce, setListResetNonce ] = useState(0);
    const [ listRefreshNonce, setListRefreshNonce ] = useState(0);
    const [ objectsOrder, setObjectsOrder ] = useState(safeJSONParse(sessionStorage.getItem(orderName)) ||'');
    const [ objectsDesc, setObjectsDesc ] = useState(safeJSONParse(sessionStorage.getItem(descName))===true);
    const [ filterStatus, setFilterStatus ] = useState( safeJSONParse(sessionStorage.getItem(filterName)) || deObjecttatus);
    const [ showDebtorState, setShowDebtorState ] = useState(readShowDebtor);
    const showDebtor = Boolean(params.objectPaymentControl && showDebtorState);

    const setShowDebtor = (next) => {
        if (!params.objectPaymentControl) return;
        setShowDebtorState((prev) => {
            const value = typeof next === 'function' ? next(prev) : Boolean(next);
            try {
                _localSet(SHOW_DEBTOR_STORAGE_KEY, value ? '1' : '0');
            } catch {
                /* ignore */
            }
            return value;
        });
    };

    useEffect(()=>{
        sessionStorage.setItem(filterName, JSON.stringify(filterStatus))
    },[filterStatus])

    useEffect(()=>{
        sessionStorage.setItem(orderName, JSON.stringify(objectsOrder));
    },[objectsOrder])
    
    useEffect(()=>{
        sessionStorage.setItem(descName, JSON.stringify(objectsDesc));
    },[objectsDesc])      

    const triggerListReset = () => setListResetNonce((nonce) => nonce + 1);
    const triggerListRefresh = () => setListRefreshNonce((nonce) => nonce + 1);
 
    const values = {
        showSpinner, setShowSpinner,
        objectsOrder, setObjectsOrder,
        objectsDesc, setObjectsDesc, 
        filterStatus, setFilterStatus,
        showDebtor, setShowDebtor,
        listResetNonce,
        triggerListReset,
        listRefreshNonce,
        triggerListRefresh,
    } 

    return (
        <ObjectContext.Provider value={values}>
            {children}
        </ObjectContext.Provider>
    )
}
